import React from 'react';

export default function Footer() {
  return (
    <footer
      style={{
        marginTop: 'auto',
        paddingTop: 32,
        paddingBottom: 32,
        textAlign: 'center',
        fontSize: 14,
        color: '#64748b',
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <p style={{ margin: '0 0 12px 0' }}>
          In case of any issues, please contact our support at{' '}
          <a
            href="mailto:support@bergregions.pl"
            style={{
              color: '#3b82f6',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseOver={(e) => (e.target.style.color = '#2563eb')}
            onMouseOut={(e) => (e.target.style.color = '#3b82f6')}
          >
            support@bergregions.pl
          </a>
        </p>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 24,
          flexWrap: 'wrap',
        }}
      >
        <a
          href="/privacy-policy"
          style={{
            color: '#64748b',
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseOver={(e) => (e.target.style.color = '#3b82f6')}
          onMouseOut={(e) => (e.target.style.color = '#64748b')}
        >
          Privacy Policy
        </a>
        <span style={{ color: '#cbd5e1' }}>•</span>
        <a
          href="/data-deletion"
          style={{
            color: '#64748b',
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseOver={(e) => (e.target.style.color = '#3b82f6')}
          onMouseOut={(e) => (e.target.style.color = '#64748b')}
        >
          User Data Deletion
        </a>
      </div>
    </footer>
  );
}
